export function arrayToTree(items, prop = {}) {
  const idKey = prop.id || 'id'
  const parentIdKey = prop.parentId || 'parentId'
  const childrenKey = prop.children || 'children'
  const parentIdData = prop.parentIdData || '0'
  const rootItems = []
  const lookup = {}

  for (const item of items) {
    const itemId = item[idKey]
    const parentId = item[parentIdKey]

    if (!lookup[itemId]) {
      lookup[itemId] = {[childrenKey]: []}
    }

    lookup[itemId] = {...item, [childrenKey]: lookup[itemId][childrenKey]}

    const TreeItem = lookup[itemId]

    if (parentId === parentIdData || parentId === null) {
      rootItems.push(TreeItem)
    } else {
      if (!lookup[parentId]) {
        lookup[parentId] = {[childrenKey]: []}
      }
      lookup[parentId][childrenKey].push(TreeItem)
    }
  }

  return rootItems
}
